<template>
    <div class="DoBetter">
        <!-- 行走的线 -->
        <div class="animetionLine"></div>
        <div class="center-box">
            <div class="mobile-img"></div>
            <div class="wecat"></div>
            <h3 class="title-caption" v-if='childModle.title'>{{childModle.title}}<span class="showdown"
                    v-if='childModle.showdown'>{{childModle.showdown}}</span></h3>
            <p class="text-center" v-html='childModle.center'></p>
            <ul class="text-ul" v-if='childModle.ulData'>
                <li class="text-li" v-for='(item,index) in childModle.ulData' :key='index'>
                    <h5>{{item}}</h5>
                </li>
            </ul>
            <a :href="childModle.topath.url" class="pathto pathtoUrl" v-if='childModle.topath'>{{childModle.topath.name}}</a>
            <a class="pathto pathtoForm" v-if='childModle.topath' @click='centerDialogVisible=true'>{{childModle.topath.name}}</a>
        </div>
        <h2 class="center-caption" v-if='childModle.caption'>{{childModle.caption}}</h2>
        <h2 class="center-caption-f" v-if='childModle.captionShadown' v-prlx="{ reverse: true,speed: 0.4 }">
            {{childModle.captionShadown}}</h2>
        <div class="boxBord"></div>
        <!-- 表单提交 -->
        <el-dialog title="立即咨询我们的数字营销专家" :visible.sync="centerDialogVisible" width="60%" center append-to-body class="myFrom" destroy-on-close>
            <From></From>
        </el-dialog>
    </div>
</template>
<script>
    import From from '@/components/base/fromtable'//引入表单
    export default {
        name: 'DoBetter',
        components:{From},
        props: {
            childModle: Object
        },
        data() {
            return {
                centerDialogVisible:false
            }
        }
    }
</script>
<style scoped>
    .DoBetter {
        padding: 301px 0 344px 0;
        position: relative;
    }

    .DoBetter::before {
        content: 'Custom website';
        text-transform: uppercase;
        display: none;
        position: absolute;
        font-size: 14px;
        font-weight: bold;
        color: #999999;
        top: -18px;
        left: 30px;
        z-index: 3;
        transform: rotate(90deg);

    }

    .center-box {
        width: 77%;
        min-height: 814px;
        background-color: #FFFFFF;
        padding-left: 14%;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }

    .center-box::after {
        position: absolute;
        content: '';
        display: block;
        width: 51.5%;
        height: 818px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/photo-1467232004584-a241de8bcf5d.jpg') no-repeat right;
        background-attachment: fixed;
        background-size: 46%;
        top: -396px;
        right: -20%;
    }

    .center-box::before {
        position: absolute;
        content: 'CONTACT';
        display: block;
        font-size: 150px;
        font-weight: bold;
        color: rgba(240, 240, 240, 1);
        top: 0;
        left: 0;
        transform: rotate(90deg) translate(22%, -142px);
        text-transform: uppercase;
        transform-origin: left top;
    }

    .center-caption {
        position: absolute;
        font-family: gilroybold4;
        font-size: 200px;
        font-weight: bold;
        line-height: 290px;
        text-transform: capitalize;
        color: rgba(34, 34, 34, 1);
        z-index: 4;
    }

    .wecat {
        width: 179px;
        height: 179px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/shiphao-1.png') no-repeat center center;
        background-size: cover;
        margin-bottom: 32px;
    }

    .text-center {
        max-width: 47.57%;
        font-size: 16px;
        font-weight: 400;
        line-height: 32px;
        color: rgba(112, 112, 112, 1);
    }

    .pathto {
        font-size: 16px;
        font-weight: 400;
        line-height: 32px;
        color: rgba(112, 112, 112, 1);
        margin-top: 76px;
        text-decoration: underline;
    }

    .title-caption {
        font-family: gilroybold4;
        font-size: 24px;
        font-weight: bold;
        line-height: 32px;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 37px;
    }

    .animetionLine {
        width: 20px;
        height: 250px;
        position: absolute;
        top: -65px;
        left: 60px;
        /* transform: rotate(90deg); */
        z-index: 3;
        overflow: hidden;
        display: none;
        /* background-color:red; */
    }

    .animetionLine::after {
        content: '';
        display: none;
        /* transform: rotate(90deg); */
        width: 1px;
        height: 250px;
        background-color: #999999;
        position: absolute;
        top: 0px;
        right: 50%;
        animation: linearMotion 2.5s infinite;
    }

    .boxBord {
        display: none;
    }

    .showdown {
        font-size: 64px;
        font-weight: 400;
        line-height: 64px;
        color: #ffffff;
        -webkit-text-stroke: 1px rgba(112, 112, 112, 1);
        text-stroke: 1px rgba(112, 112, 112, 1);
        padding-left: 15px;
    }
    .mobile-img{
        display: none;
    }
    .pathtoForm{
        display: none;
        cursor: pointer;
    }

    /* 线条运动 */
    @keyframes linearMotion {
        from {
            top: -250px;
        }

        to {
            top: 250px;
        }
    }


    /* ================================================================表单样式 ========================================================*/
    .myFrom .fromtable>>>.Myfrom{
        padding:0 5%;
        display: grid;
        width: 100%;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 5%;
        grid-template-areas:'Name Company'
                            'Email Tel'
                            'Captiond Captiond'
                            'DemandContent DemandContent'
                            'Submit Submit';
    }
    .fromtable>>>.subMit {
        justify-self: center;
        background-color: #000;
        width: 168px;
        height: 50px;
        border-radius: 30px;
        text-align: center;
        line-height: 50px;
        font-size: 20px;
        color: #ffffff;
    }

    .fromtable>>>.el-input__inner{
        border: none;
        border-radius: 0%;
        height: 60px;
        border-bottom: 1px solid #333;
    }
    .fromtable>>>.el-textarea__inner{
        border: 1px solid #333;
    }

    @media(max-width: 1028px) {
        .center-caption {
            font-size: 150px;
            line-height: 145%;
        }
    }

    @media(max-width: 995px) {
        .center-box::before {
            display: none;
        }

        .text-center {
            max-width: 100%;
            padding: 5%;
            /* font-size: 50px; */
            font-weight: 400;
            line-height: 200%;
            color: rgba(112, 112, 112, 1);
            background-color: rgba(255, 255, 255, .98);
            transform: translateY(0%);
        }

        .center-caption {
            font-size: 35px;
        }

        .center-box {
            width: 100%;
            min-height: 500px;
            padding: 0;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-start;
            background: #ffffff url('') no-repeat top;
            /* background-size: 100%; */
            object-fit: contain;
        }

        .center-box::after {
            display: none;
        }

        .wecat {
            display: none;
            width: 379px;
            height: 379px;
        }

        .DoBetter {
            padding: 50px 0 544px 0;
        }

        .pathto {
            display: none;
        }
    }

    /* @media(max-width: 1023px) {
        .text-center {
            max-width: 100%;
            padding: 5%;
            font-size: 50px;
            font-weight: 400;
            line-height: 200%;
            color: rgba(112, 112, 112, 1);
            background-color: rgba(255, 255, 255, .98);
            transform: translateY(80%);
        }

        .center-box {
            width: 100%;
            height: 2000px;
            padding: 0;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-start;
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/contcatus/_DSC0315.jpg') no-repeat top;
            background-size: cover;
        }

        .wecat {
            display: none;
            width: 379px;
            height: 379px;
        }

        .DoBetter {
            padding: 301px 0 544px 0;
        }

        .pathto {
            display: none;
        }

    } */
</style>


// WEBPACK FOOTER //
// src/components/main/contact/dobetter.vue